import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'
import loanHistoryReducer from './loanHistoryReducer'
import loanTransactionsReducer from './loanTransactionsReducer'

const intialTodosState = {
  refiTodos: {},
}

const todosReducer = (state = intialTodosState, action) => {
  switch (action.type) {
    case 'FETCH_REFITODOS_SUCCESS':
      return {
        ...state,
        refiTodos: action.entity,
      }
    default:
      return state
  }
}

export default combineReducers({
  byId: createByIdReducer('refiTransaction'),
  allIds: createAllIdsReducer('refiTransaction'),
  indexIds: createIndexIdsReducer('refiTransaction'),
  meta: createMetaReducer('refiTransaction'),
  todos: todosReducer,
  loanHistory: loanHistoryReducer,
  loanTransactions: loanTransactionsReducer,
})

//Selectors
export const selectLoanTransactions = (state) => {
  return state.refiTransactions.loanTransactions
}

export const selectLoanHistory = (state) => {
  return state.refiTransactions.loanHistory
}

export const selectTodos = (state) => {
  return state.refiTodos.todos || []
}

export const selectCoappTodos = (state) => {
  return state.refiTodos.coappTodos || []
}

export const selectRefiTransaction = (state, id) => {
  if (id) {
    return state.byId[id] || {}
  } else {
    return {}
  }
}

export const selectRefiTransactionIndex = (state) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectRefiTransactionMeta = (state) => {
  return state.meta || {}
}
